import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"

/** Stable category/type → label-key maps (the FE presentation layer). */
const CATEGORY_LABEL_KEYS: Record<string, TranslationKeys> = {
  material_compliance: "NOTIF/SETTINGS/CAT/MATERIAL_COMPLIANCE",
  questionnaires: "NOTIF/SETTINGS/CAT/QUESTIONNAIRES",
  documents: "NOTIF/SETTINGS/CAT/DOCUMENTS",
  account: "NOTIF/SETTINGS/CAT/ACCOUNT",
}

const TYPE_LABEL_KEYS: Record<string, TranslationKeys> = {
  declaration_ready_for_review: "NOTIF/SETTINGS/TYPE/DECL_READY",
  declaration_processing_failed: "NOTIF/SETTINGS/TYPE/DECL_FAILED",
  questionnaire_ready: "NOTIF/SETTINGS/TYPE/QUEST_READY",
  questionnaire_failed: "NOTIF/SETTINGS/TYPE/QUEST_FAILED",
  document_ingestion_failed: "NOTIF/SETTINGS/TYPE/DOC_FAILED",
}

export const notificationCategoryLabelKey = (
  category: string,
): TranslationKeys => CATEGORY_LABEL_KEYS[category] ?? "NOTIF/SETTINGS/FALLBACK"

export const notificationTypeLabelKey = (type: string): TranslationKeys =>
  TYPE_LABEL_KEYS[type] ?? "NOTIF/SETTINGS/FALLBACK"
